import { Skeleton } from "@shared-kernel/primary/shared/shadcn/ui/skeleton";
import { CardListItem } from "./card-list-item.content";

interface ActivityCardSkeletonProps {
  /** Show tertiary text skeleton line */
  showTertiary?: boolean;
}

export const ActivityCardSkeleton = ({ showTertiary = true }: ActivityCardSkeletonProps) => (
  <CardListItem
    avatar={<Skeleton className="size-12 rounded-full" />}
    content={
      <div className="space-y-1.5">
        <Skeleton className="h-4 w-32" />
        <Skeleton className="h-3 w-48" />
        {showTertiary && <Skeleton className="h-3 w-24" />}
      </div>
    }
  />
);
